import React from "react";
import EmulatorConfigView from "./EmulatorConfigView";

export default function VistaTelemetria() {
  return (
    <EmulatorConfigView
      subsystem="TLM"
      title="Telemetría"
      icon="📡"
      description="Configura las once variables ambientales, inerciales y de navegación incluidas en el emulador de Telemetría."
    />
  );
}
